module.exports = __webpack_public_path__ + "static/img/p_01.904f022.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/p_01.jpg
// module id = akT1
// module chunks = 9